import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import { initWeatherRequest, getWeatherSuccess, getWeatherFailure } from '../Reducers/weatherDetailsReducer';

export const fetchWeatherDetails = () => {
  return async dispatch => {
    dispatch(initWeatherRequest());

    try {
      const sessionToken = await AsyncStorage.getItem('sessionToken');

      if (!sessionToken) {
        throw new Error('Session token not found');
      }

      const response = await clientConfigPath.put('/apps/weather-fetch', {
        payload: {},
        header: {
          sessionToken,
        },
      });

      console.log("weather details",response.data?.payload);
      
      dispatch(getWeatherSuccess(response.data?.payload || {}));
    } catch (error) {
      console.log('Weather API error:', error?.message || error);
      dispatch(getWeatherFailure());
    }
  };
};

